import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Coffee } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-700 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-xl shadow-lg border-b border-gray-200' 
        : 'bg-transparent'
    }`}>
      <nav className="px-8 lg:px-16">
        <div className="max-w-8xl mx-auto">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/cinnamon-design-6" className="flex items-center space-x-3 group">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-orange-700 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <Coffee className="h-6 w-6 text-white" />
                </div>
              </div>
              <div>
                <div className={`text-2xl font-serif font-bold transition-colors duration-300 ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>
                  Claude's Special
                </div>
                <div className={`text-xs font-medium tracking-wider uppercase transition-colors duration-300 ${
                  isScrolled ? 'text-amber-600' : 'text-amber-200'
                }`}>
                  Ceylon Cinnamon
                </div>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-12">
              <Link
                to="/cinnamon-design-6"
                className={`relative text-lg font-medium transition-all duration-300 ${
                  isActive('/cinnamon-design-6') 
                    ? isScrolled ? 'text-amber-600' : 'text-amber-200'
                    : isScrolled
                      ? 'text-gray-700 hover:text-amber-600'
                      : 'text-white/90 hover:text-white'
                }`}
              >
                Home
                {isActive('/cinnamon-design-6') && (
                  <div className={`absolute -bottom-1 left-0 w-full h-0.5 ${
                    isScrolled ? 'bg-amber-600' : 'bg-amber-200'
                  }`}></div>
                )}
              </Link>
              <Link
                to="/ceylon-cinnamon-design-6"
                className={`relative text-lg font-medium transition-all duration-300 ${
                  isActive('/ceylon-cinnamon-design-6') 
                    ? isScrolled ? 'text-amber-600' : 'text-amber-200'
                    : isScrolled
                      ? 'text-gray-700 hover:text-amber-600'
                      : 'text-white/90 hover:text-white'
                }`}
              >
                Ceylon Cinnamon
                {isActive('/ceylon-cinnamon-design-6') && (
                  <div className={`absolute -bottom-1 left-0 w-full h-0.5 ${
                    isScrolled ? 'bg-amber-600' : 'bg-amber-200'
                  }`}></div>
                )}
              </Link>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`p-2 rounded-lg transition-colors duration-200 ${
                  isScrolled 
                    ? 'text-gray-700 hover:bg-gray-100' 
                    : 'text-white hover:bg-white/10'
                }`}
              >
                {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="md:hidden pb-6">
              <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-6 space-y-4 mt-4">
                <Link
                  to="/cinnamon-design-6"
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 text-lg font-medium rounded-lg transition-all duration-200 ${
                    isActive('/cinnamon-design-6') 
                      ? 'text-amber-600 bg-amber-50' 
                      : 'text-gray-700 hover:text-amber-600 hover:bg-gray-50'
                  }`}
                >
                  Home
                </Link>
                <Link
                  to="/ceylon-cinnamon-design-6"
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-3 text-lg font-medium rounded-lg transition-all duration-200 ${
                    isActive('/ceylon-cinnamon-design-6') 
                      ? 'text-amber-600 bg-amber-50' 
                      : 'text-gray-700 hover:text-amber-600 hover:bg-gray-50'
                  }`}
                >
                  Ceylon Cinnamon
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;